module.exports = __webpack_public_path__ + "img/google-playstore.ef0b6c5d.png";